// 免责声明弹窗 - 首次启动显示
import { useEffect, useState } from 'react';
import { Modal, Button, Typography, Space, Alert } from 'antd';
import { ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
const { Title, Paragraph } = Typography;
const STORAGE_KEY = 'heige:disclaimer-accepted';
export default function Disclaimer() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      setOpen(true);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      onCancel={() => {}}
      closable={false}
      maskClosable={false}
      footer={null}
      width={520}
      centered
      styles={{ body: { background: '#1a0f0f', padding: 24 } }}
    >
      {' '}
      <Space direction="vertical" size={14} style={{ width: '100%' }}>
        {' '}
        <Space>
          {' '}
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 24 }} />{' '}
          <Title level={4} style={{ margin: 0, color: '#e6edf3' }}>
            {' '}
            ⚠️ 使用前必读{' '}
          </Title>{' '}
        </Space>{' '}
        <Alert
          type="error"
          message="本程序仅供娱乐"
          description={
            <Space direction="vertical" size={4}>
              {' '}
              <span>• 所有股票/币种行情为公开免费 API 实时数据</span>{' '}
              <span>
                • 所有账户余额、持仓、交易、事件均为<strong>模拟</strong>
              </span>{' '}
              <span>
                • 本程序<strong>不构成任何投资建议</strong>
              </span>{' '}
              <span>• 新闻事件经抽象处理，不对应真实新闻原文</span>{' '}
            </Space>
          }
          showIcon={false}
          style={{ background: 'rgba(255, 77, 79, 0.08)', border: '1px solid #ff4d4f' }}
        />{' '}
        <Paragraph style={{ color: '#8b949e', fontSize: 12, margin: 0 }}>
          {' '}
          继续使用即表示您已知晓以上内容。
          <br /> 本程序源代码以 MIT 协议开源，仅用于技术研究和娱乐。{' '}
        </Paragraph>{' '}
        <Button
          type="primary"
          danger
          size="large"
          block
          icon={<CheckCircleOutlined />}
          onClick={handleAccept}
        >
          {' '}
          我已知晓，开始娱乐{' '}
        </Button>{' '}
      </Space>{' '}
    </Modal>
  );
}
